var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 185,
    viewBox: "0 0 568 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.723 142.188H86.4258V81.25H29.2969V142.188H0V0H29.2969V57.6172H86.4258V0H115.723V142.188Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.895 90.332C356.895 106.608 353.184 119.661 345.762 129.492C338.405 139.258 328.444 144.141 315.879 144.141C305.202 144.141 296.576 140.43 290 133.008V182.812H261.777V36.5234H287.949L288.926 46.875C295.762 38.6719 304.681 34.5703 315.684 34.5703C328.704 34.5703 338.828 39.388 346.055 49.0234C353.281 58.6589 356.895 71.9401 356.895 88.8672V90.332ZM328.672 88.2812C328.672 78.4505 326.914 70.8659 323.398 65.5273C319.948 60.1888 314.902 57.5195 308.262 57.5195C299.408 57.5195 293.32 60.9049 290 67.6758V110.938C293.451 117.904 299.603 121.387 308.457 121.387C321.934 121.387 328.672 110.352 328.672 88.2812Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M465.59 90.332C465.59 106.608 461.879 119.661 454.457 129.492C447.1 139.258 437.139 144.141 424.574 144.141C413.897 144.141 405.271 140.43 398.695 133.008V182.812H370.473V36.5234H396.645L397.621 46.875C404.457 38.6719 413.376 34.5703 424.379 34.5703C437.4 34.5703 447.523 39.388 454.75 49.0234C461.977 58.6589 465.59 71.9401 465.59 88.8672V90.332ZM437.367 88.2812C437.367 78.4505 435.609 70.8659 432.094 65.5273C428.643 60.1888 423.598 57.5195 416.957 57.5195C408.103 57.5195 402.016 60.9049 398.695 67.6758V110.938C402.146 117.904 408.298 121.387 417.152 121.387C430.629 121.387 437.367 110.352 437.367 88.2812Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.449 102.246L536.98 36.5234H567.254L524.773 158.594L522.43 164.16C516.115 177.962 505.698 184.863 491.18 184.863C487.078 184.863 482.911 184.245 478.68 183.008V161.621L482.977 161.719C488.315 161.719 492.286 160.905 494.891 159.277C497.56 157.65 499.643 154.948 501.141 151.172L504.461 142.48L467.449 36.5234H497.82L517.449 102.246Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.152 46.0077L239.203 97.1942L195.458 141.055C191.434 145.09 184.901 145.099 180.866 141.075C180.859 141.068 180.853 141.062 180.846 141.055L137.101 97.1942L188.152 46.0077Z",
    fill: "#FFB300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.901 109.576C231.838 109.576 248 93.3714 248 73.3818C248 53.3923 231.838 37.1875 211.901 37.1875C191.965 37.1875 175.803 53.3923 175.803 73.3818C175.803 93.3714 191.965 109.576 211.901 109.576Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.403 109.576C184.34 109.576 200.502 93.3714 200.502 73.3818C200.502 53.3923 184.34 37.1875 164.403 37.1875C144.467 37.1875 128.305 53.3923 128.305 73.3818C128.305 93.3714 144.467 109.576 164.403 109.576Z",
    fill: "#F22E52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.154 46.1238C195.722 52.7585 200.502 62.5104 200.502 73.3817C200.502 84.2536 195.721 94.0059 188.153 100.641C180.583 94.005 175.803 84.2531 175.803 73.3817C175.803 62.5874 180.516 52.8966 187.991 46.2653L188.154 46.1238Z",
    fill: "#00C853"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 46,
    width: 86,
    height: 86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.152 131.086C211.517 131.086 230.458 112.145 230.458 88.7803C230.458 65.4153 211.517 46.4742 188.152 46.4742C164.787 46.4742 145.846 65.4153 145.846 88.7803C145.846 112.145 164.787 131.086 188.152 131.086Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.152 131.086C211.517 131.086 230.458 112.145 230.458 88.7803C230.458 65.4153 211.517 46.4742 188.152 46.4742C164.787 46.4742 145.846 65.4153 145.846 88.7803C145.846 112.145 164.787 131.086 188.152 131.086Z",
    fill: "white",
    fillOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyLogoBlack);
export default __webpack_public_path__ + "static/media/happy-logo-black.1f9a7fe84d16a9fcaf842f13cacabc8b.svg";
export { ForwardRef as ReactComponent };